(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  function fansCollectionStock() {
    const source = document.querySelector('[data-fans-collection-stock]');
    const copySource = document.querySelector('[data-fans-collection-copy]');
    if (!source || !copySource) return;
    let stock, copy;
    try { stock=JSON.parse(source.textContent); copy=JSON.parse(copySource.textContent); } catch { return; }
    document.querySelectorAll('#gf-products .spf-product-card').forEach((card) => {
      const link=card.querySelector('.spf-product-card__title a') || card.querySelector('a[href*="/products/"]');
      const price=card.querySelector('.spf-product-card__price-wrapper');
      if (!link || !price) return;
      const handle=new URL(link.href,location.origin).pathname.split('/products/')[1]?.replace(/\/$/,'');
      const status=stock[handle] || 'unknown';
      let badge=card.querySelector('.fans-collection-stock');
      if (!badge) { badge=document.createElement('a'); badge.className='fans-collection-stock'; price.insertAdjacentElement('afterend',badge); }
      if(badge.textContent!==copy[status]) badge.textContent=copy[status];
      if(badge.getAttribute('href')!==link.getAttribute('href')) badge.setAttribute('href',link.getAttribute('href'));
      const button=card.querySelector('.spf-product__form-btn-addtocart');
      if(button && (status==='preorder'||status==='backorder'||status==='unknown')) {
        if(!button.hidden) button.hidden=true;
        let route=card.querySelector('.fans-collection-route');
        if(!route){route=document.createElement('a');route.className='fans-collection-route';button.insertAdjacentElement('afterend',route);}
        if(route.textContent!==copy[status]+' →')route.textContent=copy[status]+' →';
        if(route.getAttribute('href')!==link.getAttribute('href'))route.setAttribute('href',link.getAttribute('href'));
      }
    });
  }
  let fansCollectionQueued=false;
  const fansCollectionObserver=new MutationObserver(() => {
    if(fansCollectionQueued)return;
    fansCollectionQueued=true;
    requestAnimationFrame(()=>{fansCollectionQueued=false;fansCollectionStock();});
  });
  fansCollectionStock();
  fansCollectionObserver.observe(document.body,{childList:true,subtree:true});


  } catch(e) { console.error(e); }
})();
})();
